export class Timeoption {
constructor(
    public aptime: string){}

}
